import React from 'react';
import { connect } from 'react-redux';
import DataLauncherDropdownMenu from '../components/DataLauncherDropdownMenu';

const DataLauncherMenu = ({
  allowCreate,
  allowRead,
  code,
}) => (
  <>
    <DataLauncherDropdownMenu
      allowCreate={allowCreate}
      allowRead={allowRead}
      code={code}
    />
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { create, read } } } },
  datasets: { newDatasetCode },
}) => ({
  allowCreate: create,
  allowRead: read,
  code: newDatasetCode,
});

export default connect(mapStateToProps, null)(DataLauncherMenu);
